import type { CopyTargetLocation } from '@/components/Timeline/allocation/types';
import { AllocationPhasePosition } from '@/components/Timeline/Timeline.types';

/**
 * Split copy targets into the room and area id lists the duplicate mutations take.
 *
 * Each target carries its own `typeCategory`, so nothing has to be re-derived here. This used to be done by
 * searching the flat room/area query results, which silently dropped every target those lists did not cover
 * — the hierarchy view's rooms among them — leaving the mutation with two empty lists and no error. An
 * unexpected type therefore throws rather than being filtered away.
 */
export function splitCopyTargetsByLocationType(targets: CopyTargetLocation[]): {
    roomIds: string[];
    areaIds: string[];
} {
    const roomIds: string[] = [];
    const areaIds: string[] = [];

    for (const { id, typeCategory } of targets) {
        switch (typeCategory) {
            case 'Room':
                roomIds.push(id);
                break;
            case 'Area':
                areaIds.push(id);
                break;
            default:
                throw new Error(`Cannot copy an allocation into a "${typeCategory}" location ("${id}").`);
        }
    }

    return { roomIds, areaIds };
}

export function getPhasePosition(executionPhasePosition: number, phasePosition: number): AllocationPhasePosition {
    // TODO handle Aggregate or wrong positions > length of possible Position properly
    if (phasePosition < 0) {
        return 'Main';
    }
    if (phasePosition < executionPhasePosition) {
        return 'Before-Main';
    }
    if (phasePosition > executionPhasePosition) {
        return 'After-Main';
    }
    return 'Main';
}
